import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogLoader',
  props: {
  showLoader: Boolean,
},
  setup(__props) {

const props = __props;
const show = computed(() => {
  return props.showLoader ? true : false;
});

return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: show.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    modal: "",
    closable: false
  }, {
    container: _withCtx(() => [
      _createVNode(_component_ProgressSpinner, {
        style: {"width":"400px","height":"400px","overflow":"hidden"},
        strokeWidth: "4",
        class: "opacity-80"
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})